/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, Output, EventEmitter, ElementRef, Renderer, ViewEncapsulation } from '@angular/core';
import { OnInit, Inject, Optional, Host, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE } from '@angular/forms';

import { FormControl } from '../input/form.control';
import { RadioGroup } from './radio.group';

const /** @type {?} */ INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Radio),
    multi: true
};
export class Radio extends FormControl implements OnInit {
/**
 * 样式前缀
 */
prefixCls = 'ant-radio';
/**
 * 指定当前是否选中
 */
checked = false;
/**
 * 是否只读状态，默认为 false
 */
readOnly = false;
/**
 * 用户CSS样式
 */
class: string;
/**
 * 内部输入控件的tabIndex属性，默认情况下无需关注
 */
tabIndex: string;
/**
 * 值变更事件
 */
change = new EventEmitter<any>();
/**
 * Check变更事件
 */
check = new EventEmitter<boolean>();
/**
 * 内部默认的控件
 */
public type = 'radio';
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} compositionMode
 * @param {?} group
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private compositionMode: boolean,
private group: RadioGroup) {

        super(renderer, elementRef, compositionMode);
        this.value = 'on';
    }
/**
 * @return {?}
 */
getWrapperClass(): any {
        return {
            [`${this.getPrefixCls()}-wrapper`]: 1,
            [`${this.getPrefixCls()}-wrapper-checked`]: this.checked,
            [`${this.getPrefixCls()}-wrapper-disabled`]: this.disabled,
            [`${this.class}`]: this.class
        };
    }
/**
 * @return {?}
 */
getBoxClass(): any {
        return {
            [`${this.getPrefixCls()}`]: 1,
            [`${this.getPrefixCls()}-checked`]: this.checked,
            [`${this.getPrefixCls()}-disabled`]: this.disabled
        };
    }
/**
 * @return {?}
 */
getPrefixCls(): string {
        if (this.group && this.group.mode === 'button') {
            return `${this.prefixCls}-button`;
        }
        return this.prefixCls;
    }
/**
 * @return {?}
 */
isGroupDisabled(): boolean {
        return this.group && this.group.disabled;
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        // 处理CheckboxGroup的初始值
        if (this.group && this.value) {
            this.checked = this.group.value === this.value;
        }
        this.disabled = this.disabled || this.isGroupDisabled() || false;
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
        if (value !== null) {
            this.checked = this.value === value;
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
handleChange(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;

        const /** @type {?} */ value = this.checked ? this.value : '';
        this.onChange(value);
        this.check.emit(this.checked);
        this.change.emit(value);
        this.makeGroupChange();
    }
/**
 * 如果Checkbox在CheckboxGroup内部，则触发CheckboxGroup的值变化
 * @return {?}
 */
makeGroupChange() {
        if (this.group) {
            this.group.toggle(this.value, this.checked);
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-radio',
    templateUrl: './radio.html',
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [INPUT_CONTROL_VALUE_ACCESSOR],
    exportAs: 'radio'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE, ] }, ]},
{type: RadioGroup, decorators: [{ type: Inject, args: [forwardRef(() => RadioGroup), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'checked': [{ type: Input },],
'readOnly': [{ type: Input },],
'class': [{ type: Input },],
'tabIndex': [{ type: Input },],
'change': [{ type: Output },],
'check': [{ type: Output },],
};
}

function Radio_tsickle_Closure_declarations() {
/** @type {?} */
Radio.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Radio.ctorParameters;
/** @type {?} */
Radio.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Radio.prototype.prefixCls;
/**
 * 指定当前是否选中
 * @type {?}
 */
Radio.prototype.checked;
/**
 * 是否只读状态，默认为 false
 * @type {?}
 */
Radio.prototype.readOnly;
/**
 * 用户CSS样式
 * @type {?}
 */
Radio.prototype.class;
/**
 * 内部输入控件的tabIndex属性，默认情况下无需关注
 * @type {?}
 */
Radio.prototype.tabIndex;
/**
 * 值变更事件
 * @type {?}
 */
Radio.prototype.change;
/**
 * Check变更事件
 * @type {?}
 */
Radio.prototype.check;
/**
 * 内部默认的控件
 * @type {?}
 */
Radio.prototype.type;
/** @type {?} */
Radio.prototype.renderer;
/** @type {?} */
Radio.prototype.elementRef;
/** @type {?} */
Radio.prototype.compositionMode;
/** @type {?} */
Radio.prototype.group;
}




interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
